import script from "./templateBigScreen2.vue?vue&type=script&setup=true&lang=js"
export * from "./templateBigScreen2.vue?vue&type=script&setup=true&lang=js"

import "./templateBigScreen2.vue?vue&type=style&index=0&id=1c7fedee&lang=less"

const __exports__ = script;

export default __exports__